<template>
  <div>
      <topTab :changeTabIndex='3'></topTab>
      <iospage></iospage>    
      <bottomMsg></bottomMsg>
  </div>
</template>

<script>
// @ is an alias to /src
import iospage from "@/components/ios/ios.vue"
import bottomMsg from "@/components/bottomMsg/bottomMsg.vue"
import topTab from "@/components/topTab/topTab.vue"
export default {
  name: 'home',
  components: {
    iospage,
    bottomMsg,
    topTab
  }
}
</script>
